import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "store";
import { Button } from "design_system/src";
import { formatPrice } from "helpers/formatPrice";
import { getLatestPreOffer, isApprovedPreOffer } from "models/loanOffer/helpers/preOffer.helpers";
import { LoanPreOfferStatus } from "models/loanOffer/enums/loanOffer.enums";

const PRE_OFFER_STATUS_LABEL: Record<LoanPreOfferStatus, string> = {
  [LoanPreOfferStatus.approved]: "Aprobada",
  [LoanPreOfferStatus.expired]: "Vencida",
  [LoanPreOfferStatus.rejected]: "Rechazada",
};

type Props = {
  className?: string;
};

export const ApplicationStatusButton: React.FC<Props> = ({ className }) => {
  const financialForm = useSelector(
    (state: RootState) => state.financialFormReducer.financialForm
  );

  if (!financialForm) return null;

  const preOffer = getLatestPreOffer(financialForm.loanApplication?.preOffers);

  let label: string;
  let to: string | null;

  if (!preOffer) {
    label = "Revisar documentación";
    to = `/financia-tu-moto/documentos/${financialForm._id}`;
  } else if (isApprovedPreOffer(preOffer)) {
    label = `Preaprobado: $${formatPrice(preOffer.maxFinancingAmount ?? 0)} MXN`;
    to = `/financia-tu-moto/pre-oferta/${financialForm._id}`;
  } else {
    label = `Preoferta: ${PRE_OFFER_STATUS_LABEL[preOffer.status]}`;
    to = null;
  }

  const button = (
    <Button
      color="primary"
      variant="ghost"
      scale="small"
      className="w_100_per bg_primary_25 text_primary_300"
      disabled={!to}
    >
      {label}
    </Button>
  );

  if (!to) {
    return <div className={className}>{button}</div>;
  }

  return (
    <Link to={to} className={className}>
      {button}
    </Link>
  );
};
